export const Form = {
  name: {
    component: 'FormText',
    label: 'Name',
    defaultValue: ''
  },
  nickname: {
    component: 'FormText',
    label: 'Nickname',
    defaultValue: ''
  },
  desc: {
    component: 'FormMarkdown',
    label: 'Description',
    defaultValue: ''
  },
  image: {
    component: 'FormImage',
    label: 'Image',
    defaultValue: '',
    rules: { required: false }
  },
  entranceVideoUrl: {
    component: 'FormText',
    label: 'Youtube Embed Id',
    defaultValue: '',
    rules: { required: false }
  },
  gender: {
    component: 'FormSelectGender',
    label: 'Gender',
    defaultValue: 'MALE'
  },
  dob: {
    component: 'FormDate',
    label: 'Date of Birth',
    defaultValue: null,
    rules: { required: false }
  },
  alignment: {
    component: 'FormSelectAlignment',
    label: 'Alignment',
    defaultValue: null
  },
  brandIds: {
    component: 'FormBrandList',
    label: 'Brands',
    defaultValue: []
  },
  height: {
    component: 'FormNumber',
    label: 'Height',
    defaultValue: 180
  },
  weight: {
    component: 'FormNumber',
    label: 'Weight',
    defaultValue: 200
  },
  followers: {
    component: 'FormNumber',
    label: 'Followers',
    defaultValue: 0
  },
  streak: {
    component: 'FormNumber',
    label: 'Streak',
    defaultValue: 0
  },
  // draws: {
  //   component: 'FormNumber',
  //   label: 'Draws',
  //   defaultValue: 0
  // },
  wins: {
    component: 'FormNumber',
    label: 'Wins',
    defaultValue: 0
  },
  losses: {
    component: 'FormNumber',
    label: 'Losses',
    defaultValue: 0
  },
  points: {
    component: 'FormNumber',
    label: 'Points',
    rules: { min: 0, max: 100 },
    defaultValue: 70
  },
  popularity: {
    component: 'FormNumber',
    label: 'Popularity',
    rules: { min: 0, max: 100 },
    defaultValue: 70
  },
  charisma: {
    component: 'FormNumber',
    label: 'Charisma',
    rules: { min: 0, max: 100 },
    defaultValue: 70
  },
  morale: {
    component: 'FormNumber',
    label: 'Morale',
    rules: { min: 0, max: 100 },
    defaultValue: 70
  },
  stamina: {
    component: 'FormNumber',
    label: 'Stamina',
    rules: { min: 0, max: 100 },
    defaultValue: 70
  },
  cost: {
    component: 'FormNumber',
    label: 'Cost',
    defaultValue: 50
  },
  active: {
    component: 'FormToggle',
    label: 'Active',
    defaultValue: true
  }
}

export const RelationForm = {
  gender: {
    component: 'FormSelectGender',
    label: 'Gender',
    defaultValue: 'MALE'
  },
  brandIds: {
    component: 'FormBrandList',
    label: 'Brands',
    defaultValue: []
  }
}

export const QuickForm = {
  name: {
    component: 'FormText',
    label: 'Name',
    defaultValue: ''
  }
}

export default Form
